import { GalleryService } from './../../../_services/gallery.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-image-detail',
  templateUrl: './image-detail.component.html',
  styleUrls: ['./image-detail.component.css']
})
export class ImageDetailComponent implements OnInit {
    id = 0
    imageInfo = {"id":0, "url":""}
    maxCount = 22
  constructor(private route:ActivatedRoute, private galleryService:GalleryService) { }

  ngOnInit(): void {
    this.route.params.subscribe(
      params=>{

        this.id= params['id']

        this.imageInfo=  this.galleryService.getImage(this.id)

      }
    )
  }
  }


